export const PARTICIPANT_VIEW_PROFILE = "PARTICIPANT_VIEW_PROFILE"
export const PARTICIPANT_PASSWORD_CHANGE = "PARTICIPANT_PASSWORD_CHANGE"

export const PARTICIPANT_EDIT_PROFILE = "PARTICIPANT_EDIT_PROFILE"
export const PARTICIPANT_PROFILE_SUCCESS = "PARTICIPANT_PROFILE_SUCCESS"
export const PARTICIPANT_PROFILE_ERROR = "PARTICIPANT_PROFILE_ERROR"


export const PARTICIPANT_RESET_PROFILE_FLAG = "PARTICIPANT_RESET_PROFILE_FLAG";